
window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
window.webkitRequestAnimationFrame || window.oRequestAnimationFrame;

!function () {
    var Offerbutton = {};
    Offerbutton.parse = function () {
        var ANIMATION_DURATION_MOVE = 900;
        var ANIMATION_DURATION_FADE_OUT = 200;
        var ANIMATION_DELAY = 50;
        var ANIMATION_TYPE = 'swing';
        var URL_CART = '/shop/cart';
        var SELECTOR_OFFER_NAME = 'input[name="offerName"]';
        var SELECTOR_OFFER_URL = 'input[name="offerImageUrl"]';
        var SELECTOR_OFFER_AMOUNT = 'input[name="amount"]';
        var SELECTOR_CADDY_TARGET = '.js-caddy-target';
        var SELECTOR_PROGRESS_BUTTON = '.progress-button';
        var SELECTOR_OFFER_BUTTON = '[data-rel="offerbutton"]';
        var MAXIMUM_ANIMATIONS = 42;
        var INVISIBLE = { opacity: 0 };
        var NOTIFICATION_LAYOUT = 'attached';
        var NOTIFICATION_EFFECT = 'bouncyflip';
        var NOTIFICATION_TYPE_NOTICE = 'notice';
        var NOTIFICATION_TYPE_ERROR = 'error';
        var INDICATOR_OFFER_BUTTON = 'data-rel';
        var HALF = 0.5;
        var QUARTER = 0.25;
        var ONEANDHALF = 1.5;
        $(SELECTOR_OFFER_BUTTON).each(
            function (index, element) {
                var progressButtonElement = $(element).find(SELECTOR_PROGRESS_BUTTON)[0];
                var progressButton = new UIProgressButton(progressButtonElement);
                var $form = $(element);
                var offerName = $form.find(SELECTOR_OFFER_NAME).val();
                var offerImageUrl =  $form.find(SELECTOR_OFFER_URL).val();
                var disableAjax = false;
                $form.removeAttr(INDICATOR_OFFER_BUTTON);

                /*
                 * Update state of progress button.
                 */
                var $onXHR = function() {
                    var xhr = new window.XMLHttpRequest();

                    /* Upload progress (about 50%) */
                    xhr.upload.addEventListener('progress', function(evt){
                        if (evt.lengthComputable) {
                            progressButton.setProgress((evt.loaded / evt.total));
                        }
                    }, false);

                    /* Download progress (about 50%) */
                    xhr.addEventListener('progress', function(evt){
                        if (evt.lengthComputable) {
                            //progressButton.setProgress(HALF + ((evt.loaded / evt.total) * HALF));
                        }
                    }, false);
                    return xhr;
                };

                /*
                 * The muesli could not be added to the cart.
                 */
                var $onError = function (data) {
                    if (typeof data.responseText !== 'undefined') {
                        var dataJson = $.parseJSON(data.responseText);
                        if (dataJson.error === 101 || dataJson.error === 102) {
                            progressButton.stop(-1);
                            $('[data-modal=".js-md-incompatibleCartType"]').click();
                            $('.js-offerbutton-clear-cart').on('click', function () {
                                $.ajax({
                                    url: '/shop/cart/clear',
                                    method: 'POST',
                                    success: function () {
                                        $.ajax({
                                            url: $form.attr('action'),
                                            type: $form.attr('method'),
                                            data: $form.serialize(),
                                            xhr: $onXHR,
                                            success: $onSuccess,
                                            error: $onError
                                        });
                                        $('.js-md-close').click();
                                    }
                                });
                            });
                            return false;
                        }
                    }

                    progressButton.stop(0);
                    App.Interface.Notification.add('floating', App.Template.parse('notification-cart-error', {
                        'name': offerName,
                    })).update();
                };

                /*
                 * The muesli was added successfully to the cart.
                 */
                var $onSuccess = function () {
                    Shop.Cart.update();
                    var offerAmount = $form.find(SELECTOR_OFFER_AMOUNT).val();
                    progressButton.stop(1);

                    const id = $form.find('input[name="offerId"]').val();
                    App.Interface.Api.findById('offers', id, function (offer) {
                        Shop.Cart.trackOffer(offer);
                    });
                    App.execute('Offer-Notification-Success', {
                        id: id,
                        offer: {
                            'text':     offerImageUrl,
                            'image':    {
                                path: offerImageUrl,
                            },
                            'name':     offerName,
                        },
                        amount: offerAmount,
                    });

                };

                $form.submit(function(event) {

                    /* If a ajax-query faild let's try a normal form submission. */
                    if (!disableAjax) {
                        event.preventDefault();
                        $.ajax({
                            url: $form.attr('action'),
                            type: $form.attr('method'),
                            data: $form.serialize(),
                            xhr: $onXHR,
                            success: $onSuccess,
                            error: $onError
                        });
                    }
                });
            }
        );
    };
    $(Offerbutton.parse);
    $(document).ajaxComplete(Offerbutton.parse);
} ();
